import { render } from "./boxShowCategory.vue?vue&type=template&id=e4c48e4e&scoped=true"
import script from "./boxShowCategory.vue?vue&type=script&lang=js"
export * from "./boxShowCategory.vue?vue&type=script&lang=js"

import "./boxShowCategory.vue?vue&type=style&index=0&id=e4c48e4e&scoped=true&lang=css"

import exportComponent from "F:\\Project Coustomer\\vue film\\film\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c48e4e"]])

export default __exports__